import { Component } from 'react';
import { connect } from 'react-redux';

import LoaderSpinner from 'components/atoms/LoaderSpinner';
import { bindActionCreators } from 'redux';
import { setOutlineIntervalAction } from 'store/actions/mapActions';
import {
    DataDisplayType,
    OpenModal,
    PortType,
    PositionType,
    RootState,
    SwitchType,
    ToolTipType,
    TransitType,
    UserType,
} from 'types';
import { MainControlsInterface, MapControlsInterface } from 'types/functions';
import { DateTimeFormat } from 'utils/dateTimeFormat';
import { checkDifferent, clone } from 'utils/formHandlers';
import { hasPermission } from 'utils/permission';
import { translate } from 'utils/translate';
import { twclsx } from 'utils/twclsx';

interface TransitToolTipStaticProps {
    //unused props
    outlineInterval: number;
    toolTip: ToolTipType;
    mainControls: MainControlsInterface;

    //unused props
    mapControls: MapControlsInterface;
    port: PortType;
    dateTimeFormat: DateTimeFormat;

    //unused props
    openModelFunction: OpenModal;

    //unused props
    setOutlineIntervalAction: (outlineInterval: number) => void;
    switchs: SwitchType;
    user: UserType;
}

interface TransitToolTipStaticState {
    toolTip: ToolTipType | null;
    transit: TransitType | null;
    dataDisplay: DataDisplayType;
    position: PositionType | null;
    loading: boolean;
    switchs: SwitchType;
}

class TransitToolTipStatic extends Component<TransitToolTipStaticProps, TransitToolTipStaticState> {
    constructor(props: TransitToolTipStaticProps) {
        super(props);
        this.state = {
            switchs: clone(props.switchs),
            dataDisplay: props.port.meta_data.dataDisplay,
            toolTip: clone(props.toolTip),
            position: null,
            transit: null,
            loading: true,
        };
    }

    static getDerivedStateFromProps(props: TransitToolTipStaticProps, state: TransitToolTipStaticState) {
        if (checkDifferent(props.switchs, state.switchs, true)) {
            return {
                switchs: clone(props.switchs),
            };
        }

        if (checkDifferent(props.toolTip, state.toolTip)) {
            return {
                toolTip: clone(props.toolTip),
            };
        }
        return null;
    }

    componentDidMount(): void {
        this.setState(
            {
                toolTip: this.props.toolTip,
            },
            this.loadTransitData
        );
    }

    componentDidUpdate(prevProps: TransitToolTipStaticProps, prevState: TransitToolTipStaticState) {
        if (
            checkDifferent(prevState.toolTip?.data, this.state.toolTip?.data) ||
            checkDifferent(prevState.toolTip?.dataIndex, this.state.toolTip?.dataIndex)
        ) {
            this.loadTransitData();
        }
    }

    loadTransitData = async () => {
        this.setState({ loading: true }, async () => {
            //@ts-ignore
            const { transit } = this.props.mainControls.getTransit(this.state.toolTip?.data.parent);

            this.setState({
                loading: false,
                //@ts-ignore
                transit: transit,
                position: this.props.mainControls.getBestPosition(
                    this.state.toolTip?.data.parent,
                    this.state.toolTip?.dataIndex.index,
                    {
                        //@ts-ignore
                        east_utm: this.state.toolTip?.east_utm,
                        //@ts-ignore
                        north_utm: this.state.toolTip?.north_utm,
                    },
                    this.state.toolTip?.dataIndex.type
                ),
            });
        });
    };

    getDisplay = (type: string, key: string) => {
        const dataDisplay = this.state?.dataDisplay;

        if (dataDisplay?.[type]?.[key]) {
            return dataDisplay[type][key];
        }

        return {};
    };

    displayValue = (value) => {
        if (!this.state.position) {
            return '-';
        }

        if (this.state.position[value] === 'N/A') {
            return 'N/A';
        }

        return `${parseFloat(
            //@ts-ignore
            this.state.position[value] * this.getDisplay('transit', value).database2display_unit_factor
        ).toFixed(this.getDisplay('transit', value).decimal)}${this.getDisplay('transit', value).unit}`;
    };

    render() {
        return (
            <div className="  bg-white no-select  flex flex-col w-staticTooltip   overflow-hidden rounded-md">
                <div className="w-full flex flex-col p-2 ">
                    <div className="flex justify-between gap-x-2 items-start">
                        <div className="capitalize font-bold">
                            <span
                                className={twclsx(
                                    (!hasPermission(this.props.user, this.props.port.id, ['identifyTransits']) ||
                                        !this.state.switchs.identifyTransits.value) &&
                                        'blurText'
                                )}
                            >
                                {this.state.toolTip?.data.name}{' '}
                            </span>
                            ({translate(this.state.transit?.vessel.vessel_category.label)})
                        </div>
                    </div>

                    {this.state.loading ? (
                        <LoaderSpinner className="my-10 mx-20" variant="button"></LoaderSpinner>
                    ) : (
                        <>
                            <div className="flex-1 w-full truncate">
                                <div className="flex justify-between items-start">
                                    <div className="  items-center   ">
                                        <h3 className="text-activeGray text-sm leading-5 font-medium truncate">
                                            {this.state.transit?.vessel.loa_m}
                                            {this.getDisplay('vessel', 'loa_m').unit} x{' '}
                                            {this.state.transit?.vessel.beam_m}
                                            {this.getDisplay('vessel', 'beam_m').unit} ({translate('Draft')}{' '}
                                            {this.state.transit?.draft_m}
                                            {this.getDisplay('vessel', 'draft_m').unit})
                                        </h3>
                                        <p className=" text-red-500  mb-1  text-sm font-bold  leading-4 truncate">
                                            <span
                                                className={twclsx(
                                                    (!hasPermission(this.props.user, this.props.port.id, [
                                                        'identifyTransits',
                                                    ]) ||
                                                        !this.state.switchs.identifyTransits.value) &&
                                                        'blurText'
                                                )}
                                            >
                                                {this.props.dateTimeFormat
                                                    .parseDateTime(this.state.position?.valid_time_utc)
                                                    .formatDateTimeToString('dd LLL yyyy')}
                                            </span>
                                            <span className="ml-1">
                                                {this.props.dateTimeFormat
                                                    .parseDateTime(this.state.position?.valid_time_utc)
                                                    .formatDateTimeToString('HH:mm:ss Z')}
                                            </span>
                                        </p>
                                    </div>
                                </div>
                                <div className="h-px w-full bg-gray-300 my-1"></div>
                            </div>
                            {this.state.switchs.chartManoeuvreInformationOnRightColumn?.value && (
                                <div className="py-t text-sm">
                                    <div className="w-full border-collapse items-center">
                                        <div className="flex justify-start ">
                                            <div className="text-gray-600 font-bold flex justify-start text-right w-1/2">
                                                <div className="w-2/3">
                                                    {this.getDisplay('transit', 'heading_deg').name} :
                                                </div>

                                                <div className="text-black font-bold  pl-2 text-right w-1/3">
                                                    {this.displayValue('heading_deg')}
                                                </div>
                                            </div>

                                            <div className="text-gray-600 font-bold flex justify-start text-right w-1/2">
                                                <div className="w-1/2">
                                                    {this.getDisplay('transit', 'sog_mps').name} :
                                                </div>
                                                <div className="text-black font-bold  pl-2 text-left w-1/2">
                                                    {this.displayValue('sog_mps')}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex justify-start ">
                                            <div className="text-gray-600 font-bold flex justify-start text-right w-1/2">
                                                <div className="w-2/3">
                                                    {this.getDisplay('transit', 'cog_deg').name} :
                                                </div>
                                                <div className="text-black font-bold pl-2 text-right w-1/3">
                                                    {this.displayValue('cog_deg')}
                                                </div>
                                            </div>
                                            <div className="text-gray-600 font-bold flex justify-start text-right w-1/2">
                                                <div className="w-1/2">
                                                    {this.getDisplay('transit', 'rot_deg_min').name} :
                                                </div>
                                                <div className="text-black font-bold pl-2 text-left w-1/2">
                                                    {this.displayValue('rot_deg_min')}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex justify-start ">
                                            <div className="text-gray-600 font-bold flex justify-start text-right w-1/2">
                                                <div className="w-2/3">
                                                    {this.getDisplay('transit', 'drift_angle_deg').name} :
                                                </div>
                                                <div className="text-black font-bold pl-2 text-right w-1/3">
                                                    {this.displayValue('drift_angle_deg')}
                                                </div>
                                            </div>

                                            <div className="text-gray-600 font-bold flex justify-start text-right w-1/2">
                                                <div className="w-1/2">
                                                    {this.getDisplay('transit', 'crot_deg_min').name} :
                                                </div>
                                                <div className="text-black font-bold pl-2 text-left w-1/2">
                                                    {this.displayValue('crot_deg_min')}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className="flex justify-between items-center">
                                        <div>
                                            <div className="flex justify-start items-center gap-2 mr-2 ">
                                                <div className="font-bold">
                                                    <span className="text-gray-600">
                                                        {this.getDisplay('transit', 'heading_deg').name} :
                                                    </span>
                                                    <span className="text-black">
                                                        {this.displayValue('heading_deg')}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="flex justify-start items-center gap-2 mr-2 ">
                                                <div className="font-bold">
                                                    <span className="text-gray-600">
                                                        {this.getDisplay('transit', 'cog_deg').name} :
                                                    </span>
                                                    <span className="text-black">{this.displayValue('cog_deg')}</span>
                                                </div>
                                            </div>
                                            <div className="flex justify-start items-center gap-2 mr-2 ">
                                                <div className="font-bold">
                                                    <span className="text-gray-600">
                                                        {this.getDisplay('transit', 'drift_angle_deg').name} :
                                                    </span>
                                                    <span className="text-black">
                                                        {this.displayValue('drift_angle_deg')}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <div className="flex justify-start items-center gap-2 ">
                                                <div className="font-bold">
                                                    <span className="text-gray-600">
                                                        {this.getDisplay('transit', 'sog_mps').name} :
                                                    </span>
                                                    <span className="text-black">{this.displayValue('sog_mps')}</span>
                                                </div>
                                            </div>
                                            <div className="flex justify-start items-center gap-2 ">
                                                <div className="font-bold">
                                                    <span className="text-gray-600">
                                                        {this.getDisplay('transit', 'rot_deg_min').name} :
                                                    </span>
                                                    <span className="text-black">
                                                        {this.displayValue('rot_deg_min')}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="flex justify-start items-center gap-2 ">
                                                <div className="font-bold">
                                                    <span className="text-gray-600">
                                                        {this.getDisplay('transit', 'crot_deg_min').name} :
                                                    </span>
                                                    <span className="text-black">
                                                        {this.displayValue('crot_deg_min')}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>
        );
    }
}

const transitToolTipStaticStateToProps = (state: RootState) => ({
    outlineInterval: state.map.outlineInterval,
    port: state.port.port,
    switchs: state.layout.switchs,
    dateTimeFormat: state.port.dateTimeFormat,
    mainControls: state.layout.mainControls,
    mapControls: state.map.mapControls,
    openModelFunction: state.layout.openModelFunction,
    user: state.user.user,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const transitToolTipStaticDispatchToProps = (dispatch: any) => ({
    setOutlineIntervalAction: bindActionCreators(setOutlineIntervalAction, dispatch),
});

export default connect(transitToolTipStaticStateToProps, transitToolTipStaticDispatchToProps)(TransitToolTipStatic);
